import { isNumber } from "../types/isNumber";

/**
 * Checks if the given value is a valid number.
 *
 * This function first checks if the value is of type number using the `isNumber` function.
 * If not, it converts the value to a string and tests it against regular expressions
 * to determine if it represents a valid integer or floating-point number.
 *
 * @param value - The value to be checked.
 * @returns `true` if the value is a valid number, otherwise `false`.
 */
export const isValidNumber = (value: unknown): boolean => {
  if (isNumber(value)) {
    return true;
  }

  const testValue = `${value}`;
  if (testValue.match(/^-{0,1}\d+$/)) {
    return true;
  } else if (testValue.match(/^\d+\.\d+$/)) {
    return true;
  }

  return false;
};
